import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

const signupSchema = z.object({
  email: z.string().email("E-mail inválido"),
});

interface EmailStepProps {
  onSubmit: (email: string) => void;
  loading: boolean;
  defaultEmail?: string;
}

export function EmailStep({ onSubmit, loading, defaultEmail = "" }: EmailStepProps) {
  const form = useForm<z.infer<typeof signupSchema>>({
    resolver: zodResolver(signupSchema),
    defaultValues: { email: defaultEmail },
    mode: "onChange",
  });

  const handleSubmit = (values: { email: string }) => {
    onSubmit(values.email);
  };

  return (
    <div className="space-y-4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-3">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="sr-only">E-mail</FormLabel>
                <FormControl>
                  <div className="relative">
                    <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                    <Input
                      type="text"
                      inputMode="email"
                      placeholder="Digite seu e-mail"
                      autoComplete="email"
                      autoFocus
                      className="h-12 rounded-xl pl-11 text-base"
                      {...field}
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button type="submit" className="h-12 w-full rounded-xl text-base font-semibold" disabled={loading || !form.formState.isValid}>
            {loading ? "Enviando código..." : "Continuar"}
          </Button>
        </form>
      </Form>
    </div>
  );
}
